import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { useId } from 'react';
import { styled } from 'styletron-react';
import { CheckedIcon } from '../../../assets/CheckedIcon';
import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { Text } from '../../Text/Text';
import { FlexContainer } from '../../layout/FlexContainer';
const StyledCheckBox = styled(RadixCheckbox.Root, (p) => ({
    display: 'flex',
    width: sizes.checkbox.size,
    height: sizes.checkbox.size,
    flexShrink: 0,
    borderWidth: sizes.checkbox.borderWidth,
    borderColor: staticColors.checkboxUnchecked,
    borderStyle: 'solid',
    borderRadius: sizes.checkbox.borderRadius,
    backgroundColor: 'transparent',
    padding: 0,
    cursor: p.disabled ? 'not-allowed' : 'default',
    ':hover': {
        backgroundColor: staticColors.checkboxHover,
    },
}));
const StyledIndicator = styled(RadixCheckbox.Indicator, (p) => ({
    width: '100%',
    height: '100%',
    borderRadius: sizes.checkbox.borderRadius,
    outlineWidth: sizes.checkbox.borderWidth,
    outlineColor: staticColors.checkboxChecked,
    outlineStyle: 'solid',
    backgroundColor: p.$isDisabled
        ? staticColors.checkboxDisabled
        : staticColors.checkboxChecked,
}));
export const CheckBox = ({ testId, checked, label: passedLabel, labelElement, disabled = false, onCheckedChange, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const label = labelElement || _jsx(Text, { variant: 's2', children: passedLabel });
    const checkBoxId = useId();
    return (_jsxs(FlexContainer, { gap: '1/2', children: [_jsx(StyledCheckBox, { checked: checked, id: checkBoxId, disabled: disabled, onCheckedChange: onCheckedChange, children: _jsx(StyledIndicator, { $isDisabled: disabled, ...testIdAttribute, children: _jsx(FlexContainer, { fullHeight: true, fullWidth: true, center: true, children: _jsx(CheckedIcon, {}) }) }) }), label && _jsx("label", { htmlFor: checkBoxId, children: label })] }));
};
